// extracted by mini-css-extract-plugin
module.exports = {"container":"Feedback_container__2VCq0"};